module.exports = __webpack_public_path__ + "static/media/mysql.9de2ed65.png";